<template>
  <div>
    <v-text-field
      :id="id"
      :value="value"
      :appendIcon="visiblePass ? 'lock_open' : 'lock'"
      :type="visiblePass ? 'text' : 'password'"
      :rules="disablePasswordValidation ? [rules.required, rules.noWhiteSpace] : [rules.required, rules.noWhiteSpace, rules.password]"
      :label="confirmation ? `${label}` : label"
      @input="$emit('input', $event)"
      @click:append="() => (visiblePass = !visiblePass)"/>

    <v-text-field
      v-if="confirmation"
      :id="`${id}Confirmation`"
      v-model="repass"
      :type="visiblePass ? 'text' : 'password'"
      :rules="[matchPassword]"
      :label="`${label} ${localization['Confirmation'][language]}`"/>
  </div>
</template>

<script>
import localization from '../../../translationDict.json';

// eslint-disable-next-line no-useless-escape
const strongRegex = new RegExp('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})');

export default {
  props: {
    confirmation: {type: Boolean, default: false},
    value: {type: String, default: ''},
    label: {type: String, default: 'Password'},
    id: {type: String, default: 'password'},
    language: {type: String, default: 'en'},
    disablePasswordValidation: {type: Boolean, default: false},
  },
  data: () => ({
    visiblePass: false,
    repass: '',
  }),
  computed: {
    matchPassword: function () {
      return this.value === this.repass || this.localization['Password mismatch'][this.language];
    },
    rules: function () {
      return {
        noWhiteSpace: value => /^\S*$/.test(value) || this.localization['No white spaces'][this.language],
        password: value => strongRegex.test(value) || this.localization['Password validation'][this.language],
        required: value => !!value || this.localization['Password required'][this.language],
      };
    },
  },
  async created () {
    this.localization = JSON.parse(JSON.stringify(localization));
  },
};
</script>



// WEBPACK FOOTER //
// src/components/views/bits/Password.vue